// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"105":"6de717b7b311e7a8","340":"74516fdc9a886f5f"}[chunkId] + ".js";
};